
const VocabReligions = {
    'agnosticism' : ['Agnosticismo', 'Agnostic'],
    'judaism' : ['Judaísmo', 'Judaism'],
    'christianism' : ['Cristianismo', 'Christianism'],
  }
  export default VocabReligions;
    